import { Box, CircularProgress } from "@mui/material";
import NavakranthiMainLogo from "../../assets/navakranthi-logo.png";
import keshavapurLogo from "../../assets/keshavapurLogo.jpeg"
import { useData } from "../../context/DataContext";
import { getClientTheme } from "../../theme/clientTheme";

function LoadingComponent() {
  const { user_client_id } = useData();
  const clientLogo = user_client_id;
  const clientTheme = getClientTheme(user_client_id);

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Spinner */}
        <CircularProgress
          size={90}
          thickness={3}
          sx={{
            color: clientTheme.activeBg,   // ✅ dynamic color
            position: "absolute",
            filter: `drop-shadow(0 0 10px ${clientTheme.activeBorder})`,
          }}
        />

        {/* Farmer Logo */}
        <Box
          component="img"
          src={clientLogo === 1 ? NavakranthiMainLogo : keshavapurLogo}
          alt="Loading"
          sx={{
            width: 50,
            height: 50,
            objectFit: "contain",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
      </Box>

      {/* Animation */}
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); opacity: 0.85; }
            50% { transform: scale(1.12); opacity: 1; }
            100% { transform: scale(1); opacity: 0.85; }
          }
        `}
      </style>
    </Box>
  );
}

export default LoadingComponent;
